import script from "./image-attribute.vue?vue&type=script&setup=true&lang=ts"
export * from "./image-attribute.vue?vue&type=script&setup=true&lang=ts"

import "./image-attribute.vue?vue&type=style&index=0&id=9e8fb22e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e8fb22e"]])

export default __exports__